<template>
  <div class="wrapper-freespins">
    <p v-if="!isFinishedGame" class="title-freespins">{{ $t('free_spins_popups.finish_free_spin') }}</p>
    <p v-if="isFinishedGame" class="title-freespins">
      {{ $t('free_spins_popups.prize_game_is_over', { prize: getCurrentPrize }) }}
    </p>
    <div class="main-content-popups-freeSpin-wrapper">
      <div v-if="!isCounterFinish || isFinishFreeSpin" class="main-content-popups-freeSpin-box">
        <p class="text-freespins text-congratulations">
          {{ $t('free_spins_popups.win_free_spin', { win: getTotalWinFreeSpin, currencyCode: currency }) }}
        </p>
        <p class="text-freespins">{{ $t('free_spins_popups.real_money', { currencyCode: currency }) }}</p>
      </div>
      <div v-if="isCounterFinish && !isFinishFreeSpin" class="main-content-popups-freeSpin-box">
        <p class="text-freespins text-congratulations">{{ $t('free_spins_popups.counter_finished') }}</p>
      </div>
    </div>
    <ButtonPopup :closePopup="true" :text="btnCloseText" @closePopup="closePopup" />
  </div>
</template>

<script lang="ts">
import Vue from 'vue';
import { mapGetters } from 'vuex';
import ButtonPopup from '@/components/freeSpinsPopups/componentsPopup/ButtonPopup.vue';
import { ACTION } from '@/store/ACTION';
import { Utils } from '@/utils/Utils';

export default Vue.extend({
  name: 'FinishFreeSpin',
  props: {
    closing: Boolean
  },
  components: {
    ButtonPopup
  },
  computed: {
    ...mapGetters([
      'getAchievementCurrency',
      'getTotalWinFreeSpin',
      'getTournamentFreeSpinCurrency',
      'getAmountLeftSpinsAchievement',
      'getAmountLeftSpinsTournament',
      'getFreeRoundsCurrency',
      'isAchievementBG',
      'isAchievementFS',
      'isAchievementPrizeGame'
    ]),
    btnCloseText(): string {
      return <string>this.$i18n.t('free_spins_popups.continue') || '';
    },
    currency(): string {
      const currency = this.getFreeRoundsCurrency || this.getAchievementCurrency || this.getTournamentFreeSpinCurrency;
      return Utils.formatCurrencyCodeToMili(currency);
    },
    isFinishFreeSpin(): boolean {
      return this.getAmountLeftSpinsAchievement === 0 || this.getAmountLeftSpinsTournament === 0;
    },
    isCounterFinish(): boolean {
      return typeof this.getTotalWinFreeSpin !== 'string';
    },
    isFinishedGame(): boolean {
      return this.isAchievementBG || this.isAchievementFS;
    },
    getCurrentPrize(): string {
      return this.isAchievementPrizeGame ? this.getPrizeGame : '';
    },
    getPrizeGame(): string {
      switch (true) {
        case this.isAchievementBG:
          return <string>this.$i18n.t('free_spins_popups.bonus_game');
        case this.isAchievementFS:
          return <string>this.$i18n.t('free_spins_popups.free_spins_game');
        default:
          return '';
      }
    }
  },
  methods: {
    closePopup(): void {
      promoApp.eventEmitter.emit(ACTION.HIDE_FREESPIN_FINISH);
    }
  },
  watch: {
    closing: function () {
      this.closePopup();
    }
  }
});
</script>

<style scoped></style>
